import React, { Component } from "react";
import './index.less';
import platform from "Pub/js/platform";
const { NCButtonGroup, NCButton, NCMenu, NCDropdown } = platform.base;
/**
 * datasource - 按钮描述 数据源
 * {
        code:'addAppClass', - 按钮编码
        name: "增加应用分类", - 按钮名称
        type: "primary", - 按钮类型
        group: true, - 需要按钮组组内按钮
        isshow:true - 是否显示
        divide: 组合分割按钮（参数‘btn’和‘divide’）
    },
 * onClick - 按钮 Click 事件
 */
class CreateButton extends Component {
    constructor(props) {
        super(props);
    }

    
    createBtn = btns => {
        return btns.map(item => {
            if (item.isshow) {
                if (item.divide == 'btn') {
                    return (
                        <NCButton
                            className='divide-btn'
                            key={item.code}
                            colors={item.type}
                            fieldid={item.fieldid || item.code}
                            disabled={item.disabled}
                            onClick={() => {
                                this.props.onClick(item.code);
                            }}
                        >
                            {item.name}
                        </NCButton>
                    );
                } else if (item.divide == 'select') {
                    //分割按钮
                    var menu = (
                        <NCMenu 
                            onClick={() => {
                                this.props.onClick(item.code);
                            }}
                        >
                            <NCMenu.Item key="1" fieldid={item.fieldid || item.code}>
                                <div>{item.name}</div>
                            </NCMenu.Item>
                        </NCMenu>
                    );
                    return (
                        <NCDropdown overlay={menu} trigger={['click']} fieldid={item.dropdownFieldid}>
                            <NCButton
                                className='margin-left-1'
                                key={item.code}
                                colors={item.type}
                                fieldid={item.fieldid || item.code}
                                is_arrow={true}
                                style={{ minWidth: 18 }}
                            >
                                <i className="iconfont icon-hangcaozuoxiala1"></i>
                            </NCButton>
                        </NCDropdown>
                    );
                } else {
                    return (
                        <NCButton
                            className={`margin-left-6 ${
                                item.className ? item.className : ""
                            }`}
                            key={item.code}
                            colors={item.type}
                            fieldid={item.fieldid || item.code}
                            disabled={item.disabled}
                            onClick={() => {
                                this.props.onClick(item.code);
                            }}
                        >
                            {item.name}
                        </NCButton>
                    );
                }
            } else {
                return null;
            }
        });
    };
    createBtnGroup = btnGroup => {
        if (btnGroup.length > 0) {
            const isShowBtns = btnGroup.filter(item => item.isshow);
            const btns = this.createBtn(btnGroup);
            return isShowBtns.length === 1 ? btns : <NCButtonGroup>{btns}</NCButtonGroup>;
        } else {
            return null;
        }
    };
    createButton = dataSource => {
        // 按钮组
        let btnGroup = dataSource.filter(item => item.group);
        // 独立按钮
        let btns = dataSource.filter(item => !item.group);
        return (
            <div>
                <div style={{ marginLeft: 6 }}>{this.createBtnGroup(btnGroup)}</div>
                {this.createBtn(btns)}
            </div>
        );
    };
    render() {
        return (
            <div
                className={`buttons-component ${
                    this.props.className ? this.props.className : ""
                }`}
            >
                {this.createButton(this.props.dataSource)}
            </div>
        );
    }
}
export default CreateButton;
